import React from "react";
import { Tabber } from "nectar-ui";
import CustomerInfoTab from "./tabs/CustomerInfoTab";
import { useQuery } from "react-query";
import { fetchCustomerInfo } from "@services/customer";
import { CustomHeading, HeadingContainer, Subtitle, TitleContainer } from "@pages/style";
import CustomerDocumentsTab from "./tabs/CustomerDocumentsTab";
import { ContactKindMap } from "@customTypes/responses/customer";
import Skeleton from "react-loading-skeleton";

const subtext: ContactKindMap = {
  COMPANY: "Encontre as informações da sua empresa e os documentos relacionados a ela.",
  PERSON: "Encontre suas informações pessoais e os documentos relacionados a você.",
};

const ProfilePage: React.FC = () => {
  const { data: customerData, isLoading } = useQuery({
    queryKey: ["customerInfo"],
    queryFn: fetchCustomerInfo,
  });

  return (
    <div>
      <HeadingContainer>
        <TitleContainer>
          <CustomHeading margin="xs">Seu perfil</CustomHeading>
          <Subtitle color="gray" size="lg" noMargin>
            {isLoading ? <Skeleton height={16} width={440} /> : subtext[customerData?.contactKind]}
          </Subtitle>
        </TitleContainer>
      </HeadingContainer>

      <Tabber>
        <Tabber.Tab title="Seus dados">
          <CustomerInfoTab />
        </Tabber.Tab>
        <Tabber.Tab title="Seus documentos">
          <CustomerDocumentsTab />
        </Tabber.Tab>
      </Tabber>
    </div>
  );
};

export default ProfilePage;
